import { useEffect, useState } from 'react';

export default function useAppScrollParent() {
  const [scrollParent, setScrollParent] = useState<HTMLElement | undefined>();

  useEffect(() => {
    setScrollParent(
      document.querySelector<HTMLElement>('[data-app-scroll-container]') ?? undefined,
    );
  }, []);

  return scrollParent;
}
